import Component from "@glimmer/component";

interface Signature {
  Element: HTMLDivElement;
  Args: {
    withSegment?: unknown;
    onClick: (type: "first" | "second") => void;
    selected: string;
    loading?: boolean;
    disabled?: boolean;
    withoutOrCircle?: unknown;
  };
  Blocks: {
    firstButton: [];
    secondButton: [];
    firstTab: [];
    secondTab: [];
  };
}

export default class TwoButtonTabs extends Component<Signature> {
  onButtonClicked = (type: "first" | "second"): void => {
    if (type != this.args.selected) {
      this.args.onClick?.(type);
    }
  };
}
